const OsSettingsIcon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.66662 1.33398L2.72892 8.45922C2.49638 8.73827 2.38011 8.87779 2.37833 8.99563C2.37679 9.09806 2.42244 9.19552 2.50212 9.25991C2.59378 9.33398 2.7754 9.33398 3.13864 9.33398H7.99995L7.33328 14.6673L13.271 7.54208C13.5035 7.26304 13.6198 7.12351 13.6216 7.00568C13.6231 6.90324 13.5775 6.80578 13.4978 6.74139C13.4061 6.66732 13.2245 6.66732 12.8613 6.66732H7.99995L8.66662 1.33398Z" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
};

export { OsSettingsIcon };